<template>
  <div>
  </div>
</template>
<script>
export default {
  name: "VFHomePageMainte",
  data() {
    return {
      screenTitle: "ホームページ（保守作業中）",
      screenId: "PSC200",
    };
  },
}
</script>
<style scoped>

</style>